module.exports = __webpack_public_path__ + "04_mid_yellow.116cfa8b.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/boy/layer5/04_mid_yellow.png
// module id = LT2B
// module chunks = 0